import { useMutation } from '@tanstack/react-query';
import { deleteAreaRequest } from '../requests/deleteAreaRequest';
import { Alert } from '../../../components/Alert';
import { queryClient } from '../../../app/App';
import { AxiosError } from 'axios';

export function useDeleteArea() {
	const deleteArea = useMutation({
		mutationFn: async (id: number) => {
			return deleteAreaRequest(id);
		},
		onSuccess: () => {
			Alert({ message: 'Successfully deleted!', type: 'success' });
			queryClient.invalidateQueries(['AREA_LIST']);
		},
		onError: (error: AxiosError) => {
			Alert({ message: error.message, type: 'error' });
		},
	});

	return {
		deleteArea,
	};
}
